const SocialIconsData01 = [
    {
        color: "#0038e3",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#0038e3",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#0038e3",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#0038e3",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0038e3",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#0038e3",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#0038e3",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData02 = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0077b5",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData03 = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0077b5",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData04 = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0077b5",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData05 = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0077b5",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData06 = [
    {
        color: "#0038e3",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#0038e3",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#0038e3",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#0038e3",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0038e3",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#0038e3",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#0038e3",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData07 = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0077b5",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData08 = [
    {
        name: "FACEBOOK",
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        name: "DRIBBBLE",
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        name: "BEHANCE",
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
    {
        name: "INSTAGRAM",
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
]

const SocialIconsData09 = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#0077b5",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]


const SocialIconsData10 = [
    {
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#ea4c89",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#007bb6",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#fe1f49",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#1769ff",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const SocialIconsData11 = [
    {
        position: "top-left",
        name: "FACEBOOK",
        color: "#3b5998",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f",
        socialback: "LIKE US"
    },
    {
        position: "top",
        name: "TWITTER",
        color: "#00aced",
        link: "https://twitter.com/",
        icon: "fab fa-twitter",
        socialback: "FOLLOW US"
    },
    {
        position: "top-left",
        name: "LINKEDIN",
        color: "#007bb6",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in",
        socialback: "JOIN US"
    },
    {
        position: "top-right",
        name: "GOOGLE",
        color: "#dc4a38",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g",
        socialback: "FOLLOW US"
    }
]

const SocialIconsData12 = [
    {
        color: "#000",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#000",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#000",
        link: "https://accounts.google.com/signin/v2/identifier?passive=1209600&osid=1&continue=https%3A%2F%2Fplus.google.com%2F&followup=https%3A%2F%2Fplus.google.com%2F&flowName=GlifWebSignIn&flowEntry=ServiceLogin",
        icon: "fab fa-google-plus-g"
    },
    {
        color: "#000",
        link: "https://dribbble.com/",
        icon: "fab fa-dribbble"
    },
    {
        color: "#000",
        link: "https://www.linkedin.com/",
        icon: "fab fa-linkedin-in"
    },
    {
        color: "#000",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
    {
        color: "#000",
        link: "https://www.behance.net/",
        icon: "fab fa-behance"
    },
]

const sampleSocialIconsData = [
  {
    color: "#3b5998",
    link: "https://www.facebook.com/",
    icon: "fab fa-facebook-f",
  },
  {
    color: "#00aced",
    link: "https://twitter.com/",
    icon: "fab fa-twitter",
  },
  {
    color: "#fe1f49",
    link: "https://www.instagram.com/",
    icon: "fab fa-instagram",
  },
  {
    color: "#0077b5",
    link: "https://www.linkedin.com/",
    icon: "fab fa-linkedin-in",
  },
];
export { sampleSocialIconsData,SocialIconsData01, SocialIconsData02, SocialIconsData03, SocialIconsData04, SocialIconsData05, SocialIconsData06, SocialIconsData07, SocialIconsData08, SocialIconsData09, SocialIconsData10, SocialIconsData11, SocialIconsData12 }